import { GridComponent } from './grid.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        GridComponent
    ],
    imports: [ 
        CommonModule
    ],
    exports: [
        GridComponent
    ],
    providers: [],
})
export class GridModule {}